import { render, staticRenderFns } from "./AddCertificate.vue?vue&type=template&id=46400ed6&scoped=true&"
import script from "./AddCertificate.vue?vue&type=script&lang=js&"
export * from "./AddCertificate.vue?vue&type=script&lang=js&"
import style0 from "./AddCertificate.vue?vue&type=style&index=0&id=46400ed6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46400ed6",
  null
  
)

export default component.exports